let filters = $('.filters');
if (filters.length > 0) {
	let listingWrapper = $('.listing-wrapper');
	listingWrapper.imagesLoaded(
		function () {
			listingWrapper.isotope(
				{
					itemSelector: 'article',
				}
			);
		}
	);

	filters.on('click', 'a', function () {
		let filterValue = $(this).attr('data-filter');
		listingWrapper.isotope(
			{
				filter: filterValue
			}
		);
	});
}
